import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import NotificationMessageSchema, {
  NotificationMessageParams,
} from "notifications/messages/notification-message-schema";

export default class NotificationMessage {
  public static fromJSON(json: unknown): NotificationMessage | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const parsed = NotificationMessageSchema.deserialize(json);
    return new NotificationMessage(parsed);
  }

  public get value(): string {
    return this._value;
  }

  public constructor(params: NotificationMessageParams) {
    const value = NotificationMessageSchema.validateParams(params);
    this._value = value;
  }

  public toJSON(): string {
    return this.value;
  }

  public clone(): NotificationMessage {
    return new NotificationMessage(this.value);
  }

  public isEqualTo(other: NotificationMessage): boolean {
    return this.value === other?.value;
  }

  public toString(): string {
    return this.value;
  }

  private readonly _value: string;
}
